import React from 'react'
import { Box, Display } from '@gousto-internal/citrus-react'
import { RecipeTag } from './RecipeTag'

export const RecipeTagRow = ({ recipeTags }: { recipeTags: string[] }) => (
  <Box paddingH={[2, null]} display={Display.Flex}>
    {recipeTags.map((recipeTag) => (
      <Box paddingRight={[2, null, 1]} key={recipeTag}>
        <RecipeTag key={recipeTag} tagText={recipeTag} />
      </Box>
    ))}
  </Box>
)
